import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";
import {BeatLoader} from "react-spinners";
import SignupAdsFacebookCanvas from "../signup-ads-facebook-canvas/component";
import SignupAdsFacebookCarousel from "../signup-ads-facebook-carousel/component";
import SignupAdsFacebookVideo from "../signup-ads-facebook-video/component";

class SignupAdsFacebook extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            learn_more: false,
            quotes: null,
            market: null,
            image: null,
            website: null,
            tips: [],
            industry: {},
            customIndustry: null,
            ad_types: {
                canvas: {available: true, selected: true},
                carousel: {available: true, selected: false},
                video: {available: true, selected: false}
            },
            carousel: [],
            video: null,
            available: false
        };
    };

    componentDidMount() {
        this._updateData();
    }

    _updateData() {
        this.setState({
            tips: [
                {title: this._renderText("item_42")},
                {title: this._renderText("item_43")},
                {title: this._renderText("item_44")},
                {title: this._renderText("item_45")},
                {title: this._renderText("item_46")},
                {title: this._renderText("item_47")}
            ],
            selected: this.props.setChannel,
            quotes: this.props.setQuotes,
            industry: this.props.setIndustry,
            customIndustry: this.props.setCustomIndustry,
            image: this.props.setImage,
            website: this.props.setWebsite,
            market: salesChannelRegister.get('market'),
            available: this.props.setAvailable
        });
    }

    _placement() {
        try {
            let query = {
                industry: this.state.customIndustry ? this.state.customIndustry : this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: this._renderQuotes(),
                website: this.state.website ? this.state.website : (this._renderText("item_60") + salesChannelRegister.get("market")),
                image: this.state.image.url,
                saleschannel: salesChannelRegister.get("name"),
                pageTitle: salesChannelRegister.get('socialTitle'),
                pageImage: salesChannelRegister.get('socialIcon')
            };
            const stringified = queryString.stringify(query);
            let url = 'https://placement.' + dataRegister.domain;
            if (dataRegister.domain === "localhost") {
                url = 'https://placement.devsaleschannel.com';
            }
            var popUp = window.open(url + "/" + langRegister.lang() + "/facebook?" + stringified, '_blank');
        } catch (e) {
            console.log(e);
            window.open('https://placement.' + dataRegister.domain + "/" + langRegister.lang() + "/facebook", '_blank');
        }
    }

    _selectAdType(item) {
        try {
            for (let key in this.state.ad_types) {
                if (key === item) {
                    this.state.ad_types[key].selected = true;
                } else {
                    this.state.ad_types[key].selected = false;
                }
            }
            this.setState({ad_types: this.state.ad_types})
        } catch (e) {
        }
    }

    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in this.state.quotes) {
                    sortable.push([this.state.quotes[key], this.state.quotes[key].index]);
                }
                sortable.sort(function (a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });
            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }

    _renderAdImage() {
        if (this.state.image) {
            return (
                <div className={Styles.imagesContainerItem}>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            <div style={{backgroundImage: "url(" + this.state.image.url + ")"}}
                                 className={Styles.imagesContainerItemInnerUploadImage}/>
                        }
                    </div>
                </div>
            )
        }
    }

    _renderIndustry() {
        if (this.state.customIndustry) {
            return this.state.customIndustry;
        } else {
            return this.state.industry.name;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerLeftItem}>
                {
                    this.state.selected && this.state.available &&
                    <div onClick={() => this._placement()} className={Styles.contentContainerLeftItemPlacement}>
                        <img src={require("../../assets/images/plus_sign_white_small.png")}
                             className={Styles.contentContainerLeftItemPlacementIcon}/>
                    </div>
                }
                <div className={
                    cx(Styles.contentContainerLeftItemInner,
                        {
                            [Styles.contentContainerLeftItemInnerActive]: !this.state.selected,
                        })
                }>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemInnerOverlay,
                                {
                                    [Styles.contentContainerLeftItemInnerOverlayActive]: !this.state.selected,
                                })
                        }
                    >
                        {
                            !this.state.selected &&
                            <div onClick={() => {
                                if (this.state.available) {
                                    this.props.selectChannel("facebook");
                                    this.setState({selected: !this.state.selected})
                                }
                            }}
                                 className={
                                     cx(Styles.contentContainerLeftItemInnerOverlayButton,
                                         {
                                             [Styles.contentContainerLeftItemInnerOverlayButtonDisabled]: !this.state.available,
                                         })
                                 }>
                                {
                                    this.state.available &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.available &&
                                    this._renderText("item_65")
                                }
                            </div>
                        }
                        <div className={Styles.contentContainerLeftItemInnerOverlayTitle}>
                            Facebook <span
                            className={Styles.contentContainerLeftItemInnerOverlayTitleSmall}>social ads</span>
                        </div>
                        {
                            this.state.tips.filter((item, key) => {
                                return !this.state.learn_more && key < 3 || this.state.learn_more && key > 2
                            }).map((prop, i) => {
                                return (
                                    <div key={i}
                                         className={Styles.contentContainerLeftItemInnerOverlayItem}>
                                        &#x2b; {prop.title}
                                    </div>
                                )
                            })
                        }
                        <div onClick={() => {
                            this.setState({learn_more: !this.state.learn_more})
                        }} className={Styles.contentContainerLeftItemInnerOverlayReadMore}>
                            {
                                this.state.learn_more &&
                                <span>{this._renderText("item_28")}</span>
                            }
                            {
                                !this.state.learn_more &&
                                <span>{this._renderText("item_29")}</span>
                            }
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftItemFacebookInnerTop}>
                        <div className={Styles.contentContainerLeftItemFacebookInnerTopIcon}>
                            {
                                (!salesChannelRegister.get('facebookId') || !salesChannelRegister.get('socialIcon')) &&
                                <img
                                    className={Styles.contentContainerLeftItemFacebookInnerTopIconLogo}
                                    src={require("../../assets/images/Autopilot_Favicon_Inv_Gardient.png")}/>
                            }
                            {
                                salesChannelRegister.get('facebookId') && salesChannelRegister.get('socialIcon') &&
                                <img className={Styles.contentContainerLeftItemFacebookInnerTopIconLogo}
                                     src={salesChannelRegister.get('socialIcon')}/>
                            }
                        </div>
                        <div
                            className={Styles.contentContainerLeftItemFacebookSponsorContainer}>
                            <div className={Styles.contentContainerLeftItemFacebookSponsorContainerName}>
                                {
                                    (!salesChannelRegister.get('facebookId') || !salesChannelRegister.get('socialTitle')) &&
                                    <span>{this._renderText("item_61")}</span>
                                }
                                {
                                    salesChannelRegister.get('facebookId') && salesChannelRegister.get('socialTitle') &&
                                    <span>{salesChannelRegister.get('socialTitle')}</span>
                                }
                            </div>
                            <div
                                className={Styles.contentContainerLeftItemFacebookSponsorContainerText}>
                                <div>{this._renderText("item_13")} •</div>
                                <img src={require("../../assets/images/globe.svg")}
                                     className={Styles.contentContainerLeftItemFacebookSponsorContainerTextGlobe}/>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftFacebookItemAdText}>
                        {this._renderQuotes()}
                    </div>
                    {
                        (this.state.customIndustry || this.state.industry) && this.state.image && this.state.ad_types.canvas.available && this.state.ad_types.canvas.selected &&
                        <SignupAdsFacebookCanvas website={this.state.website}
                                                 industry={this.state.customIndustry ? this.state.customIndustry : this.state.industry.name}
                                                 image={this.state.image}/>
                    }
                    {
                        this.state.ad_types.carousel.available && this.state.ad_types.carousel.selected &&
                        <SignupAdsFacebookCarousel/>
                    }
                    {
                        this.state.ad_types.video.available && this.state.ad_types.video.selected &&
                        <SignupAdsFacebookVideo/>
                    }
                </div>
                <div className={Styles.contentContainerLeftItemBottom}>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemBottomIconContainer,
                                {
                                    [Styles.contentContainerLeftItemBottomIconContainerActive]: this.state.selected,
                                })
                        }
                    >
                        <img
                            className={Styles.contentContainerLeftItemBottomIconContainerIconFb}
                            src={require("../../assets/images/facebook_logo_icon.svg")}/>
                    </div>
                    {
                        !this.state.selected && this.state.available &&
                        <img onClick={() => {
                            this.props.selectChannel("facebook");
                            this.setState({selected: !this.state.selected}, () => {
                                if (!this.state.selected) {
                                    this._selectAdType("canvas")
                                }
                            })
                        }}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_deactive.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <img onClick={() => {
                            this.props.selectChannel("facebook");
                            this.setState({selected: !this.state.selected}, () => {
                                if (!this.state.selected) {
                                    this._selectAdType("canvas")
                                }
                            })
                        }}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active.svg")}/>
                    }
                    {
                        !this.state.selected &&
                        <div className={Styles.contentContainerLeftItemBottomDots}>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: !this.state.learn_more,
                                    })
                            }/>
                            <div className={Styles.contentContainerLeftItemBottomDotsItemLine}/>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: this.state.learn_more,
                                    })
                            }/>
                        </div>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <div className={Styles.contentContainerLeftItemBottomShowBoxes}>
                            {
                                this.state.ad_types.canvas.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.canvas.selected,
                                        })
                                } onClick={() => this._selectAdType("canvas")}>
                                    <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIcon}
                                         src={require("../../assets/images/AB_Ad_Image.png")}/>
                                </div>
                            }
                            {
                                this.state.ad_types.video.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.video.selected,
                                        })
                                } onClick={() => this._selectAdType("video")}>
                                    {
                                        <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIconVideo}
                                             src={require("../../assets/images/AB_Ad_Video.png")}/>
                                    }
                                </div>
                            }
                            {
                                this.state.ad_types.carousel.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.carousel.selected,
                                        })
                                } onClick={() => this._selectAdType("carousel")}>
                                    <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIcon}
                                         src={require("../../assets/images/AB_Ad_Carusel.png")}/>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsFacebook;


// WEBPACK FOOTER //
// ./src/components/signup-ads-facebook/component.js